export default {
  namespaced: true,
  state: {
    drawer: {
      model: null,
      type: "default (no property)",
      dense: false,
      clipped: true,
      floating: false,
      mini: true,
    },
    routes: [{
        path: "/",
        name: "Dashboard",
        icon: "mdi-monitor-dashboard",
        rule: "isLogged",
      },
      {
        name: "Pengawasan Tahunan",
        icon: "mdi-account-search",
        path: "/rpt",
        rule: "isLogged",
      },
      {
        name: "Program Kerja",
        icon: "mdi-file-cog-outline",
        path: "/pkp",
        rule: "isLogged",
      },
      {
        name: "Kertas Kerja",
        icon: "mdi-file-outline",
        path: "/kertaskerja",
        rule: "isLogged",
      },
      {
        name: "Pengawasan Kertas Kerja",
        icon: "mdi-file-account-outline",
        path: "/pkk",
        rule: "isLogged",
      },
      {
      name: "Laporan Sementara",
        icon: "mdi-file-document-outline",
        path: "/lps",
        rule: "isLogged",
      },
      {
        name: "Laporan Akhir",
        icon: "mdi-file-check-outline",
        path: "/lpa",
        rule: "isLpa",
      },
      {
        name: "Approval",
        icon: "mdi-check-circle",
        path: "/approval",
        rule: "isLogged",
      },
      {
        name: "Tindak Lanjut",
        icon: "mdi-text-box-check-outline",
        path: "/tindaklanjut",
        rule: "isInputer",
      },
      {
        name: "User",
        icon: "mdi-account",
        path: "/user",
        rule: "isAdmin",
      }
    ],
  },
  mutations: {},
  actions: {},
  getters: {},
};